import { Link } from "react-router-dom";
import {
  Instagram,
  Facebook,
  MapPin,
  ShieldCheck,
  BadgeCheck,
  Clock,
  FileText,
} from "lucide-react";
import Logo from "./Logo";

const TRUST_BADGES = [
  {
    Icon: ShieldCheck,
    title: "Assurance décennale",
    subtitle: "CBA FR13-RCD-25PO2270",
  },
  {
    Icon: BadgeCheck,
    title: "Produits PRB",
    subtitle: "Certifiés NF",
  },
  {
    Icon: Clock,
    title: "10 ans de garantie",
    subtitle: "Sur tous nos chantiers",
  },
  {
    Icon: FileText,
    title: "Devis gratuit",
    subtitle: "Sous 24h",
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-white/5 py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Trust badges strip */}
        <div
          data-testid="footer-trust-badges"
          className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-14 pb-12 border-b border-white/5"
        >
          {TRUST_BADGES.map(({ Icon, title, subtitle }) => (
            <div
              key={title}
              data-testid={`footer-badge-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative flex items-center gap-3 p-4 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-[#FF5A00]/40 hover:bg-white/[0.05] transition-colors"
            >
              <div className="shrink-0 w-11 h-11 rounded-xl bg-gradient-to-br from-[#FF5A00] to-[#c44600] flex items-center justify-center text-white shadow-lg shadow-[#FF5A00]/20">
                <Icon size={20} strokeWidth={2.2} />
              </div>
              <div className="min-w-0">
                <div className="text-sm text-white font-semibold leading-tight">
                  {title}
                </div>
                <div className="text-[11px] text-neutral-400 leading-tight mt-0.5 truncate">
                  {subtitle}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <Logo className="h-16 w-auto object-contain mb-4" />
            <p className="text-neutral-400 text-sm leading-relaxed max-w-md">
              La référence du ravalement de façade haut de gamme à Valenciennes et dans
              le Nord. Garantie décennale, devis gratuit, finitions impeccables.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="#"
                aria-label="Instagram"
                className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:border-[#FF5A00] hover:text-[#FF5A00] transition-all"
                data-testid="footer-instagram"
              >
                <Instagram size={14} />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:border-[#FF5A00] hover:text-[#FF5A00] transition-all"
                data-testid="footer-facebook"
              >
                <Facebook size={14} />
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-4">
              Prestations
            </div>
            <ul className="space-y-2 text-sm text-neutral-300">
              <li>Ravalement de façade</li>
              <li>Enduit projeté</li>
              <li>Rejointoiement briques</li>
              <li>Imitation pierre</li>
              <li>Isolation extérieure</li>
              <li>Démoussage toiture</li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li>
                <a href="tel:+33763433867" className="hover:text-white">
                  07 63 43 38 67
                </a>
              </li>
              <li>
                <a href="mailto:gmcrenov@icloud.com" className="hover:text-white">
                  gmcrenov@icloud.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-neutral-400">
                <MapPin size={14} /> Valenciennes — Nord (59)
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} GMC Rénovation Façade. Tous droits réservés.</div>
          <div className="flex gap-6">
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">
              Espace admin
            </Link>
            <span>Mentions légales</span>
            <span>RGPD</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
